import { Component, OnInit, OnDestroy } from '@angular/core';

import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DialogService } from 'primeng/dynamicdialog';

import { config, messages } from 'app/constants';
import { templateTypes } from 'app/constants/templates/template-type';
import { DataService, HTTPService, HelperService } from 'app/services';
import { UpdateRecipientDialogComponent } from '../update-recipient-dialog/update-recipient-dialog.component';
import { Subscription } from 'rxjs';
import { sum } from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { getLanguagePreferences, setLanguagePreferences } from 'app/constants/language-translate';

@Component({
  selector: 'app-review-dialog',
  templateUrl: './review-dialog.component.html',
  styleUrls: ['./review-dialog.component.scss'],
  providers: [DialogService],
})
export class ReviewDialogComponent implements OnInit, OnDestroy {
  card: any = {
    reminders: {
      heading: 'Custom Reminders',
      content: 'Send the customer reminder on',
      switch: false,
    },
    receipt: {
      heading: 'Attach Receipt',
      content: '',
      switch: true,
    },
  };

  customer: any = {};
  vehicle: any = {};
  company: any = {};
  order: any = {};
  hasFollowUps: boolean = false;
  isSending: boolean = false;
  title: string = 'Review Request';
  reminders: any = [];
  data: any = {};
  subject: string = '';
  content: string = '';
  isEmailSelected: boolean = false;
  isSMSSelected: boolean = false;
  customerLableVisible: boolean = false;
  reviewConfiguration: any;
  isMarketingEnabled: boolean = false;
  isMarketingOptOutEnabled: boolean = false;
  recipients = {
    emails: [],
    phones: [],
  };
  reminderRecipients = {
    emails: [],
    phones: [],
  };
  reminderRecipientTooltip: string = '';
  notificationRecipientTooltip: string = '';
  useConfirmationRecipient: boolean = false;

  baseTamplates: any;

  receiptAttach: boolean = true;
  reviewAttach: boolean = true;

  customerSearchKey;
  customerSearchResults;
  contacts: any[] = [];
  estimateId: any;
  paymentId: any;
  timezones: any = {};
  acNotDisable: any = {
    customer: true,
  };
  orderForFollowUp: any = {};
  receiptTemplate: any = {};
  reviewTemplate: any = {};
  receiptReviewTemplate: any = {};
  reviewRequestTemplate: any = {};
  reviewReminderTemplate: any = {};
  isReviewRequestOnly: boolean = false;
  dataServiceSubscription: Subscription;
  templateKeys = {
    RECEIPT: 'receiptTemplate',
    REVIEW: 'reviewTemplate',
    RECEIPT_REVIEW: 'receiptReviewTemplate',
    REVIEW_REQUEST: 'reviewRequestTemplate',
    REVIEW_REMINDER: 'reviewReminderTemplate',
    RECEIPT_REVIEW_GOOGLE: 'receiptReviewTemplate',
    REVIEW_REQUEST_GOOGLE: 'reviewRequestTemplate',
    REVIEW_REMINDER_GOOGLE: 'reviewReminderTemplate',
  };
  isReminderDisabled: boolean = false;
  unsubscriptionTooltip: string = '';
  url: string = '';
  isLoadingReceiptURL: boolean = false;
  currentLang: string = 'en';
  companyLocalization: boolean = false;
  dummyData: any;

  constructor(
    public ref: DynamicDialogRef,
    public dConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    private httpService: HTTPService,
    private helperService: HelperService,
    public dataService: DataService,
    private translate: TranslateService,
  ) {}

  async ngOnInit() {
    const data = this.dConfig.data || {};
    try {
      const reviewConfigs: any = await this.getReviewConfigurationSettings();
      if (reviewConfigs) {
        this.setConfigurationData(reviewConfigs);
      }
    } catch (err: any) {
      this.helperService.showToaster('error', err);
    }

    this.isReviewRequestOnly = data.isReviewRequestOnly;
    const [company, { templates }]: any = await Promise.all([this.getCompanyDetails(), this.getTemplates()]);

    this.company = company.appsettings.isMultiLocationEnabled ? company.shop : company;
    this.timezones = this.company.timezones;
    this.populateTemplates(templates);
    this.companyLocalization = this.dataService.companyLocalization;

    if (data.estimateId) {
      this.dummyData = data.estimateId;
      this.estimateId = data.estimateId;
      this.getEstimatesById(data.estimateId);
    }

    if (data.paymentId) {
      this.paymentId = data.paymentId;
    } else {
      // payment id doesn't exist, disable reciept
      this.receiptAttach = false;
      this.subject = this.parseTemplate(this.reviewRequestTemplate.subject);
      this.content = this.parseTemplate(this.reviewRequestTemplate.contents);
    }

    this.setDataListener();
  }

  switchLanguage() {
    if (this.currentLang === 'en') {
      this.translate.use('fr');
      this.getTemplates('fr').then((res) => {
        this.populateTemplates(res.templates);
        this.getEstimatesById(this.dummyData);
        if (!this.dummyData) {
          if (this.isReviewRequestOnly) {
            this.subject = this.parseTemplate(this.reviewRequestTemplate.subject);
            this.content = this.parseTemplate(this.reviewRequestTemplate.contents);
          } else {
            this.subject = this.parseTemplate(this.receiptReviewTemplate.subject);
            this.content = this.parseTemplate(this.receiptReviewTemplate.contents);
          }
          this.populateReminder();
        }
      });
      this.currentLang = 'fr';
      this.httpService.updateCustomer({ _id: this.order?.customer?.customerId?.customerId || this.customer?._id, preferredLanguage: 'fr'.toUpperCase() }).then((res) => {
        this.helperService.showToaster('success', 'Language updated successfully');
      });
    } else {
      this.translate.use('en');
      this.getTemplates('en').then((res) => {
        this.populateTemplates(res.templates);
        this.getEstimatesById(this.dummyData);
        if (!this.dummyData) {
          if (this.isReviewRequestOnly) {
            this.subject = this.parseTemplate(this.reviewRequestTemplate.subject);
            this.content = this.parseTemplate(this.reviewRequestTemplate.contents);
          } else {
            this.subject = this.parseTemplate(this.receiptReviewTemplate.subject);
            this.content = this.parseTemplate(this.receiptReviewTemplate.contents);
          }
          this.populateReminder();
        }
      });
      this.httpService.updateCustomer({ _id: this.order?.customer?.customerId?.customerId || this.customer?._id, preferredLanguage: 'en'.toUpperCase() }).then((res) => {
        this.helperService.showToaster('success', 'Language updated successfully');
      });
      this.currentLang = 'en';
    }
  }

  ngOnDestroy() {
    if (this.dataServiceSubscription) {
      this.dataServiceSubscription.unsubscribe();
    }
  }

  setDataListener() {
    this.dataServiceSubscription = this.dataService.getData().subscribe(({ data }) => {
      if (data) {
        if (data.key === 'company-appdata-updated') {
          this.isMarketingEnabled = this.dataService.isMarketingEnabled;
          this.isMarketingOptOutEnabled = this.dataService.isMarketingOptOutEnabled;
          this.dataServiceSubscription.unsubscribe();
        }
      }
    });
    this.isMarketingEnabled = this.dataService.isMarketingEnabled;
    this.isMarketingOptOutEnabled = this.dataService.isMarketingOptOutEnabled;
  }

  getCompanyDetails() {
    const { companyId } = this.helperService.getCompany();
    return this.httpService.getCompanyDetails(companyId, 'fetchTimezones=true');
  }

  getEstimatesById(id: string) {
    this.httpService.getEstimateById(id).then(
      (estimate) => {
        // Setting Customer
        if (estimate.customer && estimate.customer.customerId) {
          this.customer = {
            ...estimate.customer,
            ...estimate.customer.customerId,
            customerId: estimate.customer.customerId._id,
          };
          this.isEmailSelected = estimate.customer.customerId.contactOnEmail;
          this.isSMSSelected = estimate.customer.customerId.contactOnPhone;
          this.httpService.getCustomerPreferredLanguage(this.customer.customerId).then((res) => {
            if (this.companyLocalization) {
              this.currentLang = res.preferredLanguage.toLowerCase();
              this.getTemplates(res.preferredLanguage.toLowerCase()).then((res) => {
                this.populateTemplates(res.templates);
                if (this.isReviewRequestOnly) {
                  this.subject = this.parseTemplate(this.reviewRequestTemplate.subject);
                  this.content = this.parseTemplate(this.reviewRequestTemplate.contents);
                } else {
                  this.subject = this.parseTemplate(this.receiptReviewTemplate.subject);
                  this.content = this.parseTemplate(this.receiptReviewTemplate.contents);
                }
                this.populateReminder();
              });
            } else {
              this.currentLang = 'en';
            }
          });
        }

        // Setting Vehicles
        if (estimate.vehicle && estimate.vehicle.vehicleId) {
          this.vehicle = { ...estimate.vehicle, ...estimate.vehicle.vehicleId };
        }

        // Setting Orders
        this.order = { ...estimate };

        this.orderForFollowUp = {
          _id: this.order._id,
          customer: this.order.customer && this.order.customer.customerId,
          vehicle: this.order.vehicle && this.order.vehicle.vehicleId,
        };

        if (this.orderForFollowUp.customer && this.orderForFollowUp.customer._id) {
          this.orderForFollowUp.customer.customerId = this.orderForFollowUp.customer._id;
        }

        if (this.orderForFollowUp.vehicle && this.orderForFollowUp.vehicle._id) {
          this.orderForFollowUp.vehicle.vehicleId = this.orderForFollowUp.vehicle._id;
        }
        if (!this.customer.fullName) {
          this.customer.fullName = this.customer.displayName;
        }
        this.customerSearchKey = this.customer.fullName;
        this.data = estimate;
        this.acNotDisable = { customer: false };
        this.customerLableVisible = true;

        this.getReviewConfiguration();

        // Setting templates
        if (this.isReviewRequestOnly) {
          this.subject = this.parseTemplate(this.reviewRequestTemplate.subject);
          this.content = this.parseTemplate(this.reviewRequestTemplate.contents);
        } else {
          this.subject = this.parseTemplate(this.receiptReviewTemplate.subject);
          this.content = this.parseTemplate(this.receiptReviewTemplate.contents);
        }
        this.populateReminder();

        this.useConfirmationRecipient = true;
        if (this.customer.contactId && this.customer.contactId.contactInfo) {
          this.setRecipient(this.customer.contactId.contactInfo);
        }
      },
      (error) => {
        console.error(error);
      },
    );
  }

  getReviewConfigurationSettings() {
    return this.httpService.getReviewConfiguration();
  }

  setConfigurationData(configuration: any) {
    this.reviewConfiguration = configuration;
    this.reminders = this.reviewConfiguration.review.googleReview.reminders;
    this.reviewAttach = this.reviewConfiguration.review.googleReview.review;

    if (this.reminders && this.reminders.length) {
      this.reminders.forEach((reminder, index) => {
        reminder.label = index ? ': 2 days from now' : 'tomorrow';
      });
    }

    if (this.reviewConfiguration?.review?.googleReview && !this.reviewConfiguration?.review?.googleReview?.hasOwnProperty('autoleapRatingReview')) {
      this.reviewConfiguration.review.googleReview.autoleapRatingReview = true;
    }

    this.card.reminders.switch = this.reviewConfiguration.review.googleReview.reviewReminder;
    this.populateReminder();
  }

  getReviewConfiguration() {
    this.httpService.getReviewConfiguration().then(
      (configuration) => {
        // this.reviewConfiguration = configuration;
        // this.reminders = this.reviewConfiguration.review.googleReview.reminders;
        // this.reviewAttach = this.reviewConfiguration.review.googleReview.review;

        // if (this.reminders && this.reminders.length) {
        //   this.reminders.forEach((reminder, index) => {
        //     reminder.label = index ? ': 2 days from now' : 'tomorrow';
        //   });
        // }

        // if(this.reviewConfiguration?.review?.googleReview && !this.reviewConfiguration?.review?.googleReview?.hasOwnProperty('autoleapRatingReview')) {
        //   this.reviewConfiguration.review.googleReview.autoleapRatingReview = true;
        // }

        // this.card.reminders.switch = this.reviewConfiguration.review.googleReview.reviewReminder;
        // this.populateReminder();
        this.setConfigurationData(configuration);
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  getTemplates(lang?: string) {
    const { receipt, review, review_receipt, review_request, review_reminder, review_receipt_google, review_reminder_google, review_request_google } = templateTypes;
    let typeArray: any[] = [receipt, review, review_receipt, review_request, review_reminder];
    if (!this.reviewConfiguration?.review?.googleReview?.autoleapRatingReview) {
      typeArray = [...typeArray, ...[review_receipt_google, review_reminder_google, review_request_google]];
    }

    return this.httpService.getMultipleTemplates({
      type: typeArray,
      language: lang ? lang.toUpperCase() : this.currentLang.toUpperCase(),
    });
  }

  /** Populating all templates */
  populateTemplates(templates: any[]) {
    templates.forEach((template) => {
      const templateKey = this.templateKeys[template.type];
      this[templateKey] = template;
    });

    this.populateReminder();
  }

  /** Populate all reminders */
  populateReminder() {
    if (this.reviewReminderTemplate && this.reminders) {
      this.reminders.forEach((reminder) => {
        reminder.message = this.parseTemplate(reminder.message); // parsing custom template 
      });
    }
  }

  parseTemplate(content: string) {
    const parseData = {
      pickUpDateTime: this.order.pickupDate || new Date(),
      company: this.company,
      customer: this.customer,
      vehicle: this.vehicle,
      order: {
        title: this.order.title,
        code: this.order.code,
        paid: sum([this.order.card || 0, this.order.cheque || 0, this.order.cash || 0, this.order.thirdParty || 0, this.order.creditPayment || 0]),
        authStatus: this.order.authorized ? 'approved' : 'not approved',
        orderStatus: this.order.orderStatus,
        total: this.order.total && this.order.total.grand,
      },
    };

    return this.helperService.templateParser(content, parseData, false, this.timezones);
  }

  revertParse(content: string) {
    const parseData = {
      pickUpDateTime: this.order.pickupDate || new Date(),
      company: this.company,
      customer: this.customer,
      vehicle: this.vehicle,
      order: {
        title: this.order.title,
        code: this.order.code,
        paid: this.order.card + this.order.cheque + this.order.cash,
        authStatus: this.order.authorized ? 'approved' : 'not approved',
        orderStatus: this.order.orderStatus,
        total: this.order.total && this.order.total.grand,
      },
    };

    return this.helperService.revertTemplateParsing(content, parseData);
  }

  toggleActiveState(type: string, status: boolean) {
    if (type === 'reminders') {
      this.card[type].switch = status;
    } else {
      this[type] = status;
    }

    if (['isEmailSelected', 'isSMSSelected'].includes(type)) {
      this.setRecipient(this.contacts, type);
    }
  }

  close(data: any) {
    this.ref.close(data);
  }

  customerSearch(event) {
    this.httpService.searchCustomer(event.trim(), { populateContact: true, limit: 50 }).then(
      (customer: any[]) => {
        if (customer) {
          customer.forEach((customer: any) => {
            if (customer.contactId) {
              customer.contacts = customer.contactId;
            } else {
              customer.contacts = {};
            }
          });
          this.customerSearchResults = customer;
        }
      },
      (err) => {
        console.error(err);
      },
    );
  }

  getLatestCustomerOrder(customerId: string) {
    this.httpService.getLatestCustomerOrder(customerId).then(
      (estimate) => {
        /** Setting Customer */
        if (estimate.customer && estimate.customer.customerId) {
          this.customer = {
            ...estimate.customer,
            ...estimate.customer.customerId,
          };
          this.isEmailSelected = this.customer.isEmail;
          this.isSMSSelected = this.customer.isSMS;
        }

        /** Setting Vehicles */
        if (estimate.vehicle && estimate.vehicle.vehicleId) {
          this.vehicle = { ...estimate.vehicle, ...estimate.vehicle.vehicleId };
        }

        /** Setting Orders */
        this.order = estimate;

        this.customerSearchKey = this.customer.fullName;
        this.data = estimate;
        this.acNotDisable = { customer: false };
        this.customerLableVisible = true;

        this.getReviewConfiguration();

        /** Setting templates */
        if (this.isReviewRequestOnly) {
          this.subject = this.parseTemplate(this.reviewRequestTemplate.subject);
          this.content = this.parseTemplate(this.reviewRequestTemplate.contents);
        } else {
          this.subject = this.parseTemplate(this.receiptReviewTemplate.subject);
          this.content = this.parseTemplate(this.receiptReviewTemplate.contents);
        }
        this.populateReminder();
      },
      (error) => {
        console.error(error);
      },
    );
  }

  onSearchSelect(customer: any) {
    if (!customer.isActive) {
      return;
    }

    if (customer._id) {
      this.customerSearchKey = customer.fullName || customer?.fullNameQBO;
      this.customer = {
        _id: customer._id,
        customerId: customer._id,
        phone: customer.phone,
        phone2: customer.phone2,
        notes: customer.notes,
        displayName: customer?.fullNameQBO,
        email: customer.email,
        companyName: customer.companyName,
        isFleetCustomer: customer.isFleetCustomer,
        fullName: customer?.fullName || customer?.fullNameQBO,
        isEmail: customer.contactOnEmail,
        isSMS: customer.contactOnPhone,
        contact: (customer.contacts && customer.contacts.contactInfo) || [],
      };

      if (!this.isReviewRequestOnly) {
        this.getLatestCustomerOrder(this.customer.customerId);
      }

      this.getReviewConfiguration();

      this.useConfirmationRecipient = true;
      this.customerLableVisible = true;
      this.data.customer = this.customer;
      this.isEmailSelected = this.customer.isEmail;
      this.isSMSSelected = this.customer.isSMS;
      if (!this.companyLocalization) {
        this.subject = this.parseTemplate(this.reviewRequestTemplate.subject);
        this.content = this.parseTemplate(this.reviewRequestTemplate.contents);
      }

      if (this.customer.contact.length) {
        this.setRecipient(this.customer.contact);
      }

      if (!this.estimateId && this.companyLocalization) {
        this.getCustomerPrefferedLanguageData(customer._id);
      }
    }
  }

  getCustomerPrefferedLanguageData(customerId: string) {
    this.httpService.getCustomerPreferredLanguage(customerId).then((res) => {
      if (this.companyLocalization) {
        this.currentLang = res.preferredLanguage.toLowerCase();
        this.getTemplates(res.preferredLanguage.toLowerCase()).then((res) => {
          this.populateTemplates(res.templates);
          if (this.isReviewRequestOnly) {
            this.subject = this.parseTemplate(this.reviewRequestTemplate.subject);
            this.content = this.parseTemplate(this.reviewRequestTemplate.contents);
          } else {
            this.subject = this.parseTemplate(this.receiptReviewTemplate.subject);
            this.content = this.parseTemplate(this.receiptReviewTemplate.contents);
          }
          this.populateReminder();
        });
      } else {
        this.currentLang = 'en';
      }
    });
  }

  onSearchClear() {
    this.customerSearchKey = null;
    this.customer = {};
    this.customerSearchResults = [];
    this.customerLableVisible = false;
  }

  handleNotificationPrefChange(type: string, active: boolean) {
    switch (type) {
      case 'email':
        this.isEmailSelected = active;
        return;

      case 'sms':
        this.isSMSSelected = active;
        return;

      default:
        return;
    }
  }

  preview() {
    if (this.reviewAttach || this.receiptAttach) {
      this.helperService.openPageInNewTab(`${config.redirectUrl.feedbackPreview}${this.estimateId}/${this.paymentId}?lang=${this.currentLang.toUpperCase()}&localization=${this.companyLocalization}`);
    } else {
      this.helperService.showToaster('error', messages.invalidOrMissing);
    }
  }

  downloadReceipt() {
    this.getFile();
  }

  getFile() {
    this.isLoadingReceiptURL = true;

    this.httpService.getDocument(this.paymentId).then(
      (res: any[]) => {
        if (res && res.length && res.length > 0) {
          this.url = res[0].link;
          window.open(this.url, '_blank');
        } else {
          this.helperService.openPageInNewTab(
            `${config.redirectUrl.feedbackPreview}${this.estimateId}/${this.paymentId}?lang=${this.currentLang.toUpperCase()}&localization=${this.companyLocalization}`,
          );
          // this.helperService.showToaster('error', 'Undefined');
        }

        this.isLoadingReceiptURL = false;
      },
      (err) => {
        this.helperService.showToaster('error', err);
        this.isLoadingReceiptURL = false;
      },
    );
  }

  deleteReminder(index: number) {
    if (this.reminders && this.reminders.length) {
      this.reminders.splice(index, 1);
    }
  }

  onChange(type: string, status: boolean) {
    this[type] = status;

    if (this.reviewAttach && this.receiptAttach) {
      this.subject = this.parseTemplate(this.receiptReviewTemplate.subject);
      this.content = this.parseTemplate(this.receiptReviewTemplate.contents);
    } else if (this.reviewAttach && !this.receiptAttach) {
      this.subject = this.parseTemplate(this.reviewRequestTemplate.subject);
      this.content = this.parseTemplate(this.reviewRequestTemplate.contents);
    } else if (!this.reviewAttach && this.receiptAttach) {
      this.subject = this.parseTemplate(this.receiptTemplate.subject);
      this.content = this.parseTemplate(this.receiptTemplate.contents);
    }
  }

  onSubmit() {
    if (!this.isEmailSelected && !this.isSMSSelected) {
      this.helperService.showToaster('error', 'Please select Email or SMS.');
      return;
    }

    const { review } = this.reviewConfiguration;

    if (this.data.customer && this.data.customer.customerId) {
      const data = {
        subject: this.subject,
        contents: this.content,
        smsContents: this.content,
        isSMS: this.isSMSSelected,
        isEmail: this.isEmailSelected,
        manualReviewRequest: review.googleReview.manualReviewRequest,
        autoleapRatingReview: review.googleReview.autoleapRatingReview,
        minRating: review.googleReview.minRating,
        reviewReminder: this.card.reminders.switch && !this.isReminderDisabled,
        receiptAttach: this.data._id ? this.receiptAttach : false,
        reviewAttach: this.reviewAttach,
        reminders: this.reminders,
        appreciationNote: review.googleReview.appreciationNote,
        appreciationDialogNote: review.googleReview.appreciationDialogNote,
        GRL: `${window.location.origin}/#/redirect?url=${!review.googleReview.GRL.startsWith('https://') ? `https://${review.googleReview.GRL}` : review.googleReview.GRL}&ro=${this.order.code}`,
        recipients: [...this.recipients.emails, ...this.recipients.phones],
        reminderRecipients: [...this.reminderRecipients.emails, ...this.reminderRecipients.phones],
        estimate: {
          estimateId: this.data._id,
          title: this.data.title,
          code: this.data.code,
          estimateBy: this.data.estimateBy,
          createdAt: this.data.createdAt,
        },
        customer: {
          customerId: this.data.customer.customerId._id ? this.data.customer.customerId._id : this.data.customer.customerId,
          fullName: this.data.customer.fullName || this.data.customer?.displayName,
          email: this.data.customer.email,
          companyName: this.data.customer.companyName,
          isFleetCustomer: this.data.customer.isFleetCustomer,
          phone: this.data.customer.phone,
          phone2: this.data.customer.phone2,
          notes: this.data.customer.notes,
          displayName: this.data.customer.fullNameQBO,
        },
        paymentId: this.paymentId,
      };

      if (!data.estimate.estimateId) {
        delete data.estimate;
      }

      this.isSending = true;
      this.httpService
        .sendReviewRequest(data)
        .then(
          (res) => {
            this.close({});
            if (data.reviewAttach && data.receiptAttach) {
              this.helperService.showToaster('success', messages.reviewRequestReceiptSent);
            } else if (data.receiptAttach) {
              this.helperService.showToaster('success', messages.receiptSent);
            } else if (data.reviewAttach) {
              this.helperService.showToaster('success', messages.reviewRequestSent);
            }
            this.helperService.postGainsightPXEvent('Invoices Sent', {});
          },
          (error) => {
            console.error(error);
          },
        )
        .finally(() => {
          this.isSending = false;
        });
    } else {
      this.helperService.showToaster('error', messages.selectCustomer);
    }
  }

  openUpdateRecipientDialog(type: string) {
    if (!this.isSMSSelected && !this.isEmailSelected) return;
    if (this.useConfirmationRecipient && type === 'reminder') return;

    let recipients = [];

    if (type === 'confirmation') {
      recipients = [...this.recipients.emails.map(({ value }) => value), ...this.recipients.phones.map(({ value }) => value)];
    } else {
      recipients = [...this.reminderRecipients.emails.map(({ value }) => value), ...this.reminderRecipients.phones.map(({ value }) => value)];
    }

    const ref = this.dialogService.open(UpdateRecipientDialogComponent, {
      closeOnEscape: false,
      width: '650px',
      styleClass: 'add-dialog add-receipt-modal update-contact-dialog',
      showHeader: false,
      data: {
        customerId: this.customer.customerId,
        email: this.customer.email,
        phone: this.customer.phone,
        recipients: recipients,
        contactOnPhone: this.isSMSSelected,
        contactOnEmail: this.isEmailSelected,
        isFleetCustomer: this.customer.isFleetCustomer,
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        const contactNotifMap = {};
        const recipients = {
          emails: [],
          phones: [],
        };

        if (data.contacts && data.contacts && data.contacts.length) {
          for (let i = 0; i < data.contacts.length; i++) {
            const { _id, value, contactType, isChecked, isMarketingNotifEnabled, isOperationalNotifEnabled } = data.contacts[i];
            const contact = {
              value,
              recipientId: _id,
              type: contactType,
              isMarketingNotifEnabled,
              isOperationalNotifEnabled,
            };

            contactNotifMap[_id] = { isMarketingNotifEnabled, isOperationalNotifEnabled };

            if (isChecked) {
              if (contactType === 'email') {
                recipients.emails.push(contact);
              } else {
                recipients.phones.push(contact);
              }
            }
          }
        }

        if (type === 'confirmation') {
          this.recipients = this.helperService.deepCopy(recipients);

          if (this.useConfirmationRecipient) {
            this.reminderRecipients = this.helperService.deepCopy(this.recipients);
          }
        } else {
          this.reminderRecipients = this.helperService.deepCopy(recipients);
        }

        this.setOperationalNotification(contactNotifMap);

        this.unsubscriptionTooltip = this.helperService.unsubscriptionReminderTooltip(this.reminderRecipients);
        this.isReminderDisabled = !(
          this.reminderRecipients.emails.filter(({ isOperationalNotifEnabled }) => isOperationalNotifEnabled).length +
          this.reminderRecipients.phones.filter(({ isOperationalNotifEnabled }) => isOperationalNotifEnabled).length
        );
        this.notificationRecipientTooltip = this.helperService.createContactTooltip(this.recipients, 'Confirmation');
        this.reminderRecipientTooltip = this.helperService.createContactTooltip(this.reminderRecipients, 'Reminder', true);
      }

      onClose.unsubscribe();
    });
  }

  handleReminderEnableChange(isReminderEnabled: boolean) {
    this.card.reminders.switch = isReminderEnabled;
  }

  setRecipient(contacts: any[], type: string = '') {
    this.contacts = contacts;

    if (!this.isEmailSelected) {
      this.recipients.emails = [];
      this.reminderRecipients.emails = [];
    }

    if (!this.isSMSSelected) {
      this.recipients.phones = [];
      this.reminderRecipients.phones = [];
    }

    if (contacts && contacts.length) {
      contacts.forEach(({ _id, value, contactType, isPrimary, isMarketingNotifEnabled, isOperationalNotifEnabled }: any) => {
        if (isPrimary) {
          if (contactType === 'email' && this.isEmailSelected && ['', 'isEmailSelected'].includes(type)) {
            this.recipients.emails = [
              {
                type: 'email',
                value: value,
                recipientId: _id,
                isMarketingNotifEnabled,
                isOperationalNotifEnabled,
              },
            ];
          } else if (contactType === 'mobile' && this.isSMSSelected && ['', 'isSMSSelected'].includes(type)) {
            this.recipients.phones = [
              {
                type: 'mobile',
                value: value,
                recipientId: _id,
                isMarketingNotifEnabled,
                isOperationalNotifEnabled,
              },
            ];
          }
        }
      });
    }

    if (this.useConfirmationRecipient) {
      this.reminderRecipients = this.helperService.deepCopy(this.recipients);
    }

    this.unsubscriptionTooltip = this.helperService.unsubscriptionReminderTooltip(this.reminderRecipients);
    this.isReminderDisabled = !(
      this.reminderRecipients.emails.filter(({ isOperationalNotifEnabled }) => isOperationalNotifEnabled).length +
      this.reminderRecipients.phones.filter(({ isOperationalNotifEnabled }) => isOperationalNotifEnabled).length
    );
    this.notificationRecipientTooltip = this.helperService.createContactTooltip(this.recipients, 'Confirmation');
    this.reminderRecipientTooltip = this.helperService.createContactTooltip(this.reminderRecipients, 'Reminder', true);
  }

  setOperationalNotification(contactMap: any) {
    if (this.recipients.emails && this.recipients.emails.length) {
      this.recipients.emails.forEach((recip: any) => {
        if (contactMap[recip.recipientId]) {
          recip.isMarketingNotifEnabled = contactMap[recip.recipientId].isMarketingNotifEnabled;
          recip.isOperationalNotifEnabled = contactMap[recip.recipientId].isOperationalNotifEnabled;
        }
      });
    }

    if (this.reminderRecipients.emails && this.reminderRecipients.emails.length) {
      this.reminderRecipients.emails.forEach((recip: any) => {
        if (contactMap[recip.recipientId]) {
          recip.isMarketingNotifEnabled = contactMap[recip.recipientId].isMarketingNotifEnabled;
          recip.isOperationalNotifEnabled = contactMap[recip.recipientId].isOperationalNotifEnabled;
        }
      });
    }

    if (this.recipients.phones && this.recipients.phones.length) {
      this.recipients.phones.forEach((recip: any) => {
        if (contactMap[recip.recipientId]) {
          recip.isMarketingNotifEnabled = contactMap[recip.recipientId].isMarketingNotifEnabled;
          recip.isOperationalNotifEnabled = contactMap[recip.recipientId].isOperationalNotifEnabled;
        }
      });
    }

    if (this.reminderRecipients.phones && this.reminderRecipients.phones.length) {
      this.reminderRecipients.phones.forEach((recip: any) => {
        if (contactMap[recip.recipientId]) {
          recip.isMarketingNotifEnabled = contactMap[recip.recipientId].isMarketingNotifEnabled;
          recip.isOperationalNotifEnabled = contactMap[recip.recipientId].isOperationalNotifEnabled;
        }
      });
    }
  }
}
